import storageService, { StorageServiceInterface, StorageType } from 'src/services/storage-service';

export enum StorageKeys {
    API_ACCESS_TOKEN = 'auth.accessToken',
    API_ACCESS_TOKEN_EXPIRY = 'auth.accessTokenExpiry',
    API_REFRESH_TOKEN = 'auth.refreshToken',
    API_REFRESH_TOKEN_EXPIRY = 'auth.refreshTokenExpiry',
}

const localStorageOptions = {
    storage: StorageType.LOCAL_STORAGE,
};

export class AuthStorageService {
    private storageService: StorageServiceInterface;

    public constructor(storageService: StorageServiceInterface) {
        this.storageService = storageService;
    }
    public setAccessToken(token: string): void {
        this.storageService.save(StorageKeys.API_ACCESS_TOKEN, token, localStorageOptions);
    }

    public setRefreshToken(token: string): void {
        this.storageService.save(StorageKeys.API_REFRESH_TOKEN, token, localStorageOptions);
    }

    public setAccessTokenExpiry(expiry: string): void {
        this.storageService.save(StorageKeys.API_ACCESS_TOKEN_EXPIRY, expiry, localStorageOptions);
    }

    public setRefreshTokenExpiry(expiry: string): void {
        this.storageService.save(StorageKeys.API_REFRESH_TOKEN_EXPIRY, expiry, localStorageOptions);
    }

    public getRefreshToken(): string | null {
        return this.storageService.get(StorageKeys.API_REFRESH_TOKEN, localStorageOptions);
    }

    public getAccessTokenExpiry(): string | null {
        return this.storageService.get(StorageKeys.API_ACCESS_TOKEN_EXPIRY, localStorageOptions);
    }

    public getRefreshTokenExpiry(): string | null {
        return this.storageService.get(StorageKeys.API_REFRESH_TOKEN_EXPIRY, localStorageOptions);
    }

    public getAccessToken(): string | null {
        return this.storageService.get(StorageKeys.API_ACCESS_TOKEN, localStorageOptions);
    }

    public clearAll(): void {
        this.storageService.remove(StorageKeys.API_ACCESS_TOKEN, localStorageOptions);
        this.storageService.remove(StorageKeys.API_ACCESS_TOKEN_EXPIRY, localStorageOptions);
        this.storageService.remove(StorageKeys.API_REFRESH_TOKEN, localStorageOptions);
        this.storageService.remove(StorageKeys.API_REFRESH_TOKEN_EXPIRY, localStorageOptions);
    }
}

export default new AuthStorageService(storageService);
